import React from 'react';
import styled from '@emotion/styled';
import type { WidthProps } from 'styled-system';
import { width } from 'styled-system';

import { Flex } from 'common/components/Flex';
import FormGroup from 'common/components/Form/FormGroup';
import { CaptionRegularCR1 } from 'common/components/Typography';
import type { ContactFormGroup } from '../types';

interface FormGroupWithSlotsProps {
  formGroup: ContactFormGroup;
}

const StyledFormGroup = styled(FormGroup)<WidthProps>`
  ${width};
`;

const FormGroupWithSlots = ({ formGroup }: FormGroupWithSlotsProps) => {
  return (
    <>
      <Flex>
        <StyledFormGroup width={1} {...formGroup}>
          {'helpText' in formGroup && formGroup.helpText && (
            <CaptionRegularCR1 mt="sp_4">{formGroup.helpText}</CaptionRegularCR1>
          )}
        </StyledFormGroup>

        {'rightSlot' in formGroup && formGroup.rightSlot}
      </Flex>

      {'bottomSlot' in formGroup && formGroup.bottomSlot}
    </>
  );
};

export default FormGroupWithSlots;
